import React from 'react';
import {
  InternalLayout,
  InternalLayoutProvider,
} from 'volto-ministerio-publico-federal/components/Layouts';
import { Links } from 'volto-ministerio-publico-federal/components/Links';
import { hasSignificantBlocks } from 'volto-ministerio-publico-federal/utils/hasSignificantBlocks';
import { RenderBlocksWithoutTitle } from '../InternalView/RenderBlocksWithoutTitle';
import { MPFAlert } from 'volto-ministerio-publico-federal/components/UI/Alert';

interface Content {
  [key: string]: unknown;
  title?: string;
  description?: string;
  /** "Ocultar título" (behavior `ministerio.publico.federal.ocultar_titulo`). */
  ocultar_titulo?: boolean;
  items?: Array<{ '@type': string; [key: string]: unknown }>;
  relatedItems?: Array<{ '@id': string; title: string }>;
  blocks?: Record<string, unknown>;
  blocks_layout?: { items?: string[] };
}

interface LinksViewProps {
  content: Content;
}

const LinksView: React.FC<LinksViewProps> = ({ content }) => {
  if (!content) return null;

  const linkItems = (content.items || []).filter(
    (item) => item['@type'] === 'Link' || item['@type'] === 'Folder',
  );
  const hasLinks = linkItems.length > 0;

  const hasBlocks = hasSignificantBlocks(
    content.blocks,
    content.blocks_layout as { items?: string[] },
  );

  const mainContent = (
    <>
      {hasBlocks && <RenderBlocksWithoutTitle content={content as any} />}
      {hasLinks && <Links items={linkItems} />}
      {!hasLinks && (
        <MPFAlert
          type="warning"
          message="Nenhum link encontrado nesta pasta."
        />
      )}
    </>
  );

  return (
    <InternalLayoutProvider
      title={content.title ?? ''}
      description={content.description}
      relatedItems={content.relatedItems}
      ocultarTitulo={content.ocultar_titulo}
      reviewState={content.review_state as string | undefined}
    >
      <InternalLayout>{mainContent}</InternalLayout>
    </InternalLayoutProvider>
  );
};

export default LinksView;
